import React from "react";

interface Args {
    couponDiscountField: React.ReactNode;
    codeDiscountField: React.ReactNode;
    paymentMethodField: React.ReactNode;
    orderSummaryField: React.ReactNode;
    isMobile: boolean;
    isCounselor: boolean;
    isKorean : boolean
}

export function PaymentSection(
    {
        couponDiscountField, codeDiscountField, paymentMethodField, orderSummaryField,
        isMobile, isCounselor, isKorean
    }: Args
) {

    const nonKoreanStrategy = ( // 영문 케이스
        <>
            {paymentMethodField}
            {orderSummaryField}
        </>
    );

    const koreanCounselorMobileStrategy = ( // 한국어 케이스
        <>
            {couponDiscountField}
            {paymentMethodField}
            {orderSummaryField}
        </>
    )

    const koreanCounselorDesktopStrategy = (  // 한국어 상담 데스크탑 케이스
        <>
            {couponDiscountField}
            {orderSummaryField}
            {paymentMethodField}
        </>
    )

    const koreanMobileStrategy = (  // 한국어 모바일
        <>
            {couponDiscountField}
            {codeDiscountField}
            {paymentMethodField}
            {orderSummaryField}
        </>
    )

    const koreanDesktopStrategy = (  // 한국어 데스크탑
        <>
            {couponDiscountField}
            {paymentMethodField}
            {codeDiscountField}
            {orderSummaryField}
        </>
    )

    const sectionRenderer = () => {  // 케이스별 분기처리
        if (!isKorean) {
            return nonKoreanStrategy;
        }

        if (isCounselor) {
            return isMobile
                ? koreanCounselorMobileStrategy
                : koreanCounselorDesktopStrategy;
        }

        return isMobile
            ? koreanMobileStrategy
            : koreanDesktopStrategy;
    };

    return (
        <>
            {sectionRenderer()}
        </>
    )
}